var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70403 12.5618C4.37123 12.5618 4.13193 12.3225 4.13193 12.0181C4.13193 11.7092 4.37123 11.4699 4.70403 11.4699H12.1375C12.4584 11.4699 12.7059 11.7092 12.7059 12.0181C12.7059 12.3225 12.4584 12.5618 12.1375 12.5618H4.70403ZM4.70403 16.0673C4.37123 16.0673 4.13193 15.828 4.13193 15.5191C4.13193 15.2147 4.37123 14.9709 4.70403 14.9709H12.1375C12.4584 14.9709 12.7059 15.2147 12.7059 15.5191C12.7059 15.828 12.4584 16.0673 12.1375 16.0673H4.70403ZM3.41474 19.9998H13.3844C15.2573 19.9998 16.2049 19.0404 16.2049 17.1547V8.50093H9.47436C8.33073 8.50093 7.7818 7.94828 7.7818 6.80465V0H3.41474C1.55296 0 0.602539 0.959501 0.602539 2.84515V17.1547C0.602539 19.0486 1.54555 19.9998 3.41474 19.9998ZM9.50767 7.31849H16.0826C16.034 6.9618 15.7762 6.62901 15.3857 6.23028L10.0525 0.822891C9.66649 0.428687 9.31352 0.170042 8.96424 0.109513V6.77134C8.96424 7.14104 9.14991 7.31849 9.50767 7.31849Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.0eb2564f61826d741072b298d7752379.svg";
export { ForwardRef as ReactComponent };